var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomerPlatformLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "customer_platform_logo",
    "data-name": "customer platform logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 251.48,
    height: 63.019,
    viewBox: "0 0 251.48 63.019",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_208",
    "data-name": "Rettangolo 208",
    width: 251.48,
    height: 63.019,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_156",
    "data-name": "Raggruppa 156",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_62",
    "data-name": "Tracciato 62",
    d: "M15.739,42.031l5.069-3.552L10.139,31l23.7-16.615,0,0L42.47,8.343a4.511,4.511,0,0,0,1.767-3.6V0L24.2,14.04,4.171,0V7.105L19.135,17.591,0,31Z",
    fill: "#f9b300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_63",
    "data-name": "Tracciato 63",
    d: "M46.542,20.354,30.8,9.326l-5.069,3.552L36.4,20.354,4.072,43.012a4.51,4.51,0,0,0-1.767,3.6v4.742l20.033-14.04,20.033,14.04V44.25L27.407,33.764Z",
    transform: "translate(2.883 11.664)",
    fill: "#f9b300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_64",
    "data-name": "Tracciato 64",
    d: "M29.4,24.044a13.1,13.1,0,0,1-3.815-9.592A13.165,13.165,0,0,1,39.065.97a12.882,12.882,0,0,1,11.15,6.111L45.808,9.637a7.452,7.452,0,0,0-6.743-3.7A8.142,8.142,0,0,0,32.954,8.3a8.537,8.537,0,0,0-2.3,6.149,8.513,8.513,0,0,0,2.3,6.113,8.15,8.15,0,0,0,6.111,2.37,7.491,7.491,0,0,0,6.743-3.669l4.407,2.557a12.838,12.838,0,0,1-11.15,6.111A13,13,0,0,1,29.4,24.044",
    transform: "translate(31.996 1.213)",
    fill: "#0081c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_65",
    "data-name": "Tracciato 65",
    d: "M40.849,25.2a8.294,8.294,0,0,1-2.777-6.556V1.2h5.073V18.238c0,2.7,1.519,4.409,4.816,4.409s4.814-1.706,4.814-4.409V1.2h5.111V18.645A8.3,8.3,0,0,1,55.11,25.2a10.4,10.4,0,0,1-7.148,2.444A10.37,10.37,0,0,1,40.849,25.2",
    transform: "translate(47.616 1.501)",
    fill: "#0081c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_66",
    "data-name": "Tracciato 66",
    d: "M48.569,21.525l4.369-2.555A5.833,5.833,0,0,0,58.9,22.934c2.854,0,4.148-1.15,4.148-2.741a2.3,2.3,0,0,0-1.222-2.111,17.9,17.9,0,0,0-4.369-1.668,16.75,16.75,0,0,1-5.372-2.406,6.265,6.265,0,0,1-2.444-5.334,6.873,6.873,0,0,1,2.482-5.593A9.083,9.083,0,0,1,58.161.97a9.9,9.9,0,0,1,9.259,5.816l-4.3,2.48a5.186,5.186,0,0,0-4.963-3.333c-2.111,0-3.408,1.074-3.408,2.593a2.427,2.427,0,0,0,1,2,16,16,0,0,0,3.927,1.629l1.778.592a15.736,15.736,0,0,1,1.665.628,7.532,7.532,0,0,1,1.63.779,7.645,7.645,0,0,1,2.447,2.3,7.063,7.063,0,0,1,.961,3.666,6.948,6.948,0,0,1-2.629,5.7,10.437,10.437,0,0,1-6.779,2.111c-5.147,0-8.739-2.444-10.184-6.408",
    transform: "translate(60.744 1.213)",
    fill: "#0081c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_67",
    "data-name": "Tracciato 67",
    d: "M76.809,1.2V6.089h-7V27.128H64.7V6.089H57.732V1.2Z",
    transform: "translate(72.205 1.501)",
    fill: "#0081c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_68",
    "data-name": "Tracciato 68",
    d: "M79.982,27.933A13.283,13.283,0,0,1,66.536,14.452,12.993,12.993,0,0,1,70.425,4.9a13.593,13.593,0,0,1,19.111,0,12.88,12.88,0,0,1,3.927,9.556A13.346,13.346,0,0,1,79.982,27.933m0-5a8.1,8.1,0,0,0,5.962-2.37,8.293,8.293,0,0,0,2.408-6.113,8.293,8.293,0,0,0-2.408-6.113,8.59,8.59,0,0,0-11.924,0,8.294,8.294,0,0,0-2.408,6.113,8.294,8.294,0,0,0,2.408,6.113,8.1,8.1,0,0,0,5.962,2.37",
    transform: "translate(83.215 1.213)",
    fill: "#0081c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_69",
    "data-name": "Tracciato 69",
    d: "M105.714,1.2V27.128h-5.075V10.311l-7.3,12.039H92.75l-7.3-12V27.128H80.34V1.2H85.6L93.045,13.46,100.454,1.2Z",
    transform: "translate(100.48 1.501)",
    fill: "#0081c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_70",
    "data-name": "Tracciato 70",
    d: "M99.109,22.239h10.925v4.888H94V1.2h15.854V6.091H99.109v5.519h9.815v4.816H99.109Z",
    transform: "translate(117.558 1.501)",
    fill: "#0081c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_71",
    "data-name": "Tracciato 71",
    d: "M117.186,27.128l-5.222-9h-3.889v9h-5.114V1.2h10.371a8.347,8.347,0,0,1,6.115,2.519,8.312,8.312,0,0,1,2.516,6.075,8.43,8.43,0,0,1-5,7.558l5.741,9.777Zm-9.111-21.15v7.668h5.258a3.72,3.72,0,0,0,3.52-3.853,3.687,3.687,0,0,0-3.52-3.815Z",
    transform: "translate(128.773 1.501)",
    fill: "#0081c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_72",
    "data-name": "Tracciato 72",
    d: "M37.01,15.426a8.689,8.689,0,0,1,6.3,2.521,8.32,8.32,0,0,1,2.555,6.185,8.327,8.327,0,0,1-2.555,6.185,8.689,8.689,0,0,1-6.3,2.521H32.454v8.517H27.343V15.426Zm0,12.631a3.761,3.761,0,0,0,3.779-3.925A3.74,3.74,0,0,0,37.01,20.2H32.454v7.853Z",
    transform: "translate(34.197 19.293)",
    fill: "#0081c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_73",
    "data-name": "Tracciato 73",
    d: "M42.408,36.465H52.3v4.888h-15V15.426h5.111Z",
    transform: "translate(46.646 19.293)",
    fill: "#0081c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_74",
    "data-name": "Tracciato 74",
    d: "M63.763,41.354l-1.557-4.666H51.873l-1.555,4.666H44.8l9.075-25.928h6.333l9.111,25.928ZM53.5,31.908h7.112L57.058,21.316Z",
    transform: "translate(56.029 19.293)",
    fill: "#0081c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_75",
    "data-name": "Tracciato 75",
    d: "M74.438,15.426v4.888h-7V41.354H62.325V20.315H55.362V15.426Z",
    transform: "translate(69.24 19.293)",
    fill: "#0081c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_76",
    "data-name": "Tracciato 76",
    d: "M80.83,20.315H70.459v6.147H80.533v4.893H70.459v10H65.35V15.426H80.83Z",
    transform: "translate(81.732 19.294)",
    fill: "#0081c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_77",
    "data-name": "Tracciato 77",
    d: "M87.054,42.16A13.286,13.286,0,0,1,73.608,28.681a13.486,13.486,0,0,1,23-9.559,12.882,12.882,0,0,1,3.927,9.559A13.346,13.346,0,0,1,87.054,42.16m0-5a8.089,8.089,0,0,0,5.962-2.37,8.292,8.292,0,0,0,2.408-6.111,8.3,8.3,0,0,0-2.408-6.115,8.59,8.59,0,0,0-11.924,0,8.3,8.3,0,0,0-2.408,6.115,8.292,8.292,0,0,0,2.408,6.111,8.089,8.089,0,0,0,5.962,2.37",
    transform: "translate(92.06 19.004)",
    fill: "#0081c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_78",
    "data-name": "Tracciato 78",
    d: "M101.636,41.354l-5.222-9H92.528v9H87.412V15.426H97.785a8.6,8.6,0,0,1,8.629,8.593,8.43,8.43,0,0,1-5,7.558l5.744,9.777ZM92.528,20.2v7.668h5.258a3.72,3.72,0,0,0,3.518-3.853A3.686,3.686,0,0,0,97.785,20.2Z",
    transform: "translate(109.325 19.293)",
    fill: "#0081c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_79",
    "data-name": "Tracciato 79",
    d: "M123.134,15.426V41.354h-5.073V24.539l-7.3,12.037h-.592l-7.3-12V41.354H97.762V15.426h5.262l7.443,12.259,7.409-12.259Z",
    transform: "translate(122.269 19.293)",
    fill: "#0081c6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerPlatformLogo);
export default __webpack_public_path__ + "static/media/customer_platform_logo.8ef89da278e943baed7877008d669aeb.svg";
export { ForwardRef as ReactComponent };